import type {
	FetchBaseQueryError,
	FetchBaseQueryMeta,
	QueryReturnValue,
} from "@reduxjs/toolkit/query";
import type { PaginatedResponse, Builder } from "../../types.js";
import { loadAllPages } from "../../utils/loadAllPages.js";
import type { Integration } from "./types.js";

export const buildIntegrationEndpoints = (builder: Builder) => ({
	getIntegrations: builder.query<
		Integration[],
		{
			companyDomainId: string;
		}
	>({
		queryFn({ companyDomainId }, _api, _extraOptions, baseQuery) {
			return loadAllPages(({ take, skip }) => {
				return baseQuery({
					url: `/v1/company-domain/${companyDomainId}/integration`,
					params: {
						take,
						skip,
					},
				}) as Promise<
					QueryReturnValue<
						PaginatedResponse<Integration>,
						FetchBaseQueryError,
						FetchBaseQueryMeta
					>
				>;
			});
		},
		providesTags: (_result, _error, arg) => [
			{ type: "Integration", id: arg.companyDomainId },
		],
	}),

	addIntegrationToLegalEntity: builder.mutation<
		Integration,
		{
			companyDomainId: string;
			legalEntityId: string;
			integrationId: string;
		}
	>({
		query: ({ companyDomainId, legalEntityId, integrationId }) => ({
			url: `/v1/company-domain/${companyDomainId}/legal-entity/${legalEntityId}/integration`,
			method: "POST",
			body: {
				integrationId,
			},
		}),
		invalidatesTags: (_result, _error, args) => [
			{ type: "Integration", id: args.companyDomainId },
		],
	}),

	syncIntegration: builder.mutation<
		{ success: boolean },
		{ companyDomainId: string; legalEntityId: string }
	>({
		query: ({ companyDomainId, legalEntityId }) => ({
			url: `/v1/company-domain/${companyDomainId}/legal-entity/${legalEntityId}/integration/sync`,
			method: "POST",
		}),
		invalidatesTags: (_result, _error, args) => [
			{ type: "Integration", id: args.companyDomainId },
		],
	}),
});
